export default (props, vars) =>
  vars?.['defaultforeach2']?.['item']?.['disabled']
    ? undefined
    : vars?.['defaultforeach2']?.['item']?.['onClick'];
